<template>
  <div class="event-tip-popup">
    <div class="event-tip-popup-shade"></div>
    <div class="event-tip-popup-content">
      <p class="event-tip-popup-text">{{ eventTipText }}</p>
      <a
        class="event-tip-popup-close j-click-tip-close"
        href="javascript:;"
        @click="hidePopup"
      ></a>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'eventTipPopup',
  props: ['eventTipText'],
  data() {
    return {};
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    hidePopup() {
      this.$emit('closeTipPopup');
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';

.event-tip-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;

  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 461px;
    height: 318px;
    background-size: 100% 100%;
    transform: translate(-50%, -50%);
    @psetbg ('share-popup-copy.png', false, false);
  }

  &-text {
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    font-size: 30px;
    color: var(--event-popup-tip-text);
    width: 80%;
    text-align: center;
  }

  &-close {
    position: absolute;
    right: 31px;
    top: 30px;
    background-size: cover;
    cursor: pointer;
    @psetbg ('close.png');
  }
}
@media screen and (orientation: landscape) {
  .event-tip-popup {
    &-close {
      position: absolute;
      @psetbg ('close-hen.png');
    }
  }
}
</style>
